/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import type { GeoIpResult } from './geolocation.types';

export async function getGeoLocationFromIp(signal?: AbortSignal) {
    return axios
        .get<GeoIpResult>('/api/recommendation/geoip', { signal })
        .then(({ data }) => data);
}

// cSpell:ignore geoip
